import { mat4 } from "gl-matrix";

export default class Camera {
  constructor(canvas) {
    this.canvas = canvas;

    this.translation = mat4.create();
    mat4.fromTranslation(this.translation, [0, 0, 50]);
    this.rotation = mat4.create();
    this.scale = mat4.create();
    mat4.fromTranslation(this.scale, [2.0, 2.0, 2.0]);

    this.ratio = canvas.width / canvas.height;

    this.projection = mat4.create();

    this.zoom = 100.0;
    mat4.ortho(
      this.projection,
      -this.zoom, // left
      this.zoom, // right
      -this.zoom / this.ratio, // bottom
      this.zoom / this.ratio, // top
      -300.0, // near
      300.0 // far
    );

    this.yaw = 0;
    this.pitch = 0;

    this.canvas.addEventListener("wheel", this.handleWheel);
  }

  getView() {
    const m = mat4.create();
    mat4.mul(m, this.rotation, this.translation);
    mat4.invert(m, m);
    return m;
  }

  handleWheel = (event) => {
    event.preventDefault();
    // this.translation[14] -= Math.sign(event.wheelDelta);

    this.zoom *= 1.0 - Math.sign(event.wheelDelta) * 0.1;
    mat4.ortho(
      this.projection,
      -this.zoom, // left
      this.zoom, // right
      -this.zoom / this.ratio, // bottom
      this.zoom / this.ratio, // top
      -300.0, // near
      300.0 // far
    );
  };

  cleanup() {
    this.canvas.removeEventListener("wheel", this.handleWheel);
  }
}
